export default `---
slug: uk
country: United Kingdom
countryCode: GB1
continent: Europe
year: 2017
title: "United Kingdom"
description: "London and beyond — pubs, rain, and surprisingly good food."
thumbnail: /images/travels/GB1/uk_thumb.jpg
relatedLinks: []
---
![uk](/images/travels/GB1/uk_thumb.jpg)

*Story coming soon — stay tuned!*

I visited United Kingdom and it was an incredible experience. Full story and photos are being written up and will appear here soon.
`;
